import styled from "@emotion/styled";
import {
  PROTIP_BACKGROUND_COLOR_GRADIENT,
  COLOR_APP_TEXT,
  IconSize,
  MOBILE_SCREEN,
} from "../../components/theme";
import { ParagraphHeaderSmall } from "../../components/typography/Paragraph";
import { StyledDescription } from "./Questionnaire";
import Lightbulb from "../../components/icons/Lightbulb";

const StyledProtip = styled.div`
  background: ${PROTIP_BACKGROUND_COLOR_GRADIENT};
  padding: 24px;
  border-radius: 16px;
  margin: 24px 0;
  ${MOBILE_SCREEN} {
    margin: 8px 0;
  }
`;

const StyledProtipHeader = styled.div`
  display: flex;
  gap: 8px;
`;

interface ProtipProps {
  text: string;
}

const Protip: React.FC<ProtipProps> = ({ text }) => {
  if (!text || text.length === 0) return null;
  return (
    <StyledProtip>
      <StyledProtipHeader>
        <Lightbulb size={IconSize.M} />
        <ParagraphHeaderSmall color={COLOR_APP_TEXT} fontWeight={700}>
          Pro Tip:
        </ParagraphHeaderSmall>
      </StyledProtipHeader>
      <StyledDescription dangerouslySetInnerHTML={{ __html: text }} />
    </StyledProtip>
  );
};

export default Protip;
